import { ZipCodeType } from '@/types'
//@ts-ignore
import LocalStorageSerializer from '@/common/localStorageSerializer'
import { LOCAL_STORAGE_FAVORITE_PRODUCTS } from '@/editor/config/tutorial'

export const extractAddress = (data: ZipCodeType ) => {
  const { zipCode, city, town, prefecture } = data
  return [`〒${zipCode}`, prefecture, city, town].join('')
}

export const validateZipCode = (value: string) => {
  if (value === '') {
    return '郵便番号を入力してください。'
  } else if (value.length !== 7) {
    return '郵便番号は7文字で入力してください。'
  }

  return ''
}

export const checkCache = (productList: any) => {
  const storageItemArray = LocalStorageSerializer.get(LOCAL_STORAGE_FAVORITE_PRODUCTS)
  if (!storageItemArray) {
    return productList
  }

  const list = productList

  const newList = list.map((item: any) => {
    const itemChange = storageItemArray.find((storageItem: any) => {
      return storageItem.productId === item.id
    })

    return {...item, estimateItemId: itemChange ? itemChange.estimateId : item.estimateItemId}
  })

  return newList
}
